import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
  logout,
} from "../../services/AuthService";
import { getMiPerfilResidente } from "../../services/ResidenteAuthService";
import { clearVersionData } from "../../services/VersionService";

import { loginPermisosAction } from "../../store/actions/PermisosActions";
import {
  SIGNUP_CONFIRMED_ACTION,
  SIGNUP_FAILED_ACTION,
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOADING_TOGGLE_ACTION,
  LOGOUT_ACTION,
} from "./ActionsTypes";

export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        const twelveHoursInMilliseconds = 12 * 60 * 60 * 1000;
        response.data.expiresIn =
          new Date(new Date().getTime() + twelveHoursInMilliseconds) * 1000;
        runLogoutTimer(
          dispatch,
          response.data.expiresIn * 1000,
          //history,
        );
        dispatch(confirmedSignupAction(response.data));
        navigate("/dashboard");
        //history.push('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  logout();
  localStorage.removeItem("userDetails");
  localStorage.removeItem("userPermissions");
  clearVersionData(); // Clear version data on logout
  navigate("/login");
  //history.push('/login');

  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, navigate) {
  return (dispatch) => {
    dispatch({ type: "LOGIN_CHECK_STARTED" }); // loading ON

    login(email, password)
      .then((response) => {
        let newTokenDetails = saveTokenInLocalStorage(response.data);
        dispatch(loginConfirmedAction(newTokenDetails));
        dispatch(loginPermisosAction());
        navigate("/dashboard");
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const errorMessage = formatError(error.response.data);
          dispatch(loginFailedAction(errorMessage));
        } else {
          const errorMessage = formatError(error);
          dispatch(loginFailedAction(errorMessage));
        }
      })
      .finally(() => {
        dispatch({ type: "LOGIN_CHECK_FINISHED" }); // loading OFF
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}

/**
 * Refresca los datos del residente desde el backend y actualiza el store + localStorage.
 * Se usa en useResidenteDataInit para cargar datos frescos en cada F5 / reload de página.
 * Retorna una Promise para que el hook pueda manejar el estado de carga.
 */
export function refreshResidenteUserAction() {
  return (dispatch) => {
    return getMiPerfilResidente()
      .then((response) => {
        if (response.data.success) {
          const freshUser = response.data.user;

          try {
            const raw = localStorage.getItem("userDetails");
            if (raw) {
              const current = JSON.parse(raw);
              const updated = { ...current, user: freshUser };
              localStorage.setItem("userDetails", JSON.stringify(updated));
              dispatch(loginConfirmedAction(updated));
            }
          } catch (error) {
            console.error(
              "refreshResidenteUserAction: Error actualizando localStorage:",
              error,
            );
          }
        }
      })
      .catch((error) => {
        console.error(
          "refreshResidenteUserAction: Error obteniendo datos del residente:",
          error,
        );
      });
  };
}
